/** zh-CN catalogue `batch` (W3-09; English: src/features/batch/batch.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'batch',
  locale: 'zh-CN',
  messages: {
    unitPx: 'px',
    cmdDistribute: '分布数值（渐变）…',
    cmdClone: '克隆到判定线…',
    cmdFill: '在两个音符之间填充…',
    cmdPath: '运动路径…',
    cmdBake: '烘焙或简化区段…',
    cmdFlatten: '合并层级…',
    cmdStagger: '错开选中内容…',
    cmdTransform: '变换…',
    cmdReverseTime: '时间反转',
    cmdStretch: '将时间拉伸为两倍长',
    cmdSqueeze: '将时间压缩为一半长',
    cmdExtrapolate: '根据前两个区段递推',
    cmdJoin: '合并区段',
    cmdReverse: '反转区段',
    cmdLink: '绑定区段',
    cmdUnlink: '解除区段绑定',
    cmdSelectLinked: '选中绑定的区段',
    cmdSplitRpe: '在播放头处拆分（RPE 线性）',
    cmdBakeQuick: '切割为直线分段',
    cmdSelectSimilar: '选中相似项',
    cmdRangeStart: '范围从此处开始',
    cmdRangeEnd: '范围到此处结束（选中该范围）',
    cmdEveryNth: '每隔 N 项保留一项…',
    cmdInvert: '反选',
    cmdPasteSpecial: '选择性粘贴…',
    txnDistribute: '分布数值',
    txnClone: '克隆到判定线',
    txnFill: '在音符之间填充',
    txnPath: '运动路径',
    txnBake: '烘焙区段',
    txnSimplify: '简化区段',
    txnFlatten: '合并层级',
    txnStagger: '错开',
    txnTransform: '变换',
    txnReverseTime: '时间反转',
    txnStretch: '拉伸时间',
    txnSqueeze: '压缩时间',
    txnExtrapolate: '递推区段',
    txnJoin: '合并区段',
    txnReverse: '反转区段',
    txnLink: '绑定区段',
    txnUnlink: '解除区段绑定',
    txnSplitRpe: '拆分区段（RPE 线性）',
    txnPasteSpecial: '选择性粘贴',
    reasonNoProject: '请先打开一个项目。',
    reasonNothingSelected: '请先选中音符或关键帧。',
    reasonNoSegments: '请先选中一个或多个区段。',
    reasonNeedTwoSegments: '请至少选中两个区段。',
    reasonJoinSelect: '请选中两个区段之间的关键帧，或两个相邻的区段。',
    reasonNotLinked: '选中的区段都没有绑定。',
    reasonNoColumn: '请先单击一个运动列（或一个区段），以明确要拆分哪个属性。',
    reasonPlayheadOutside: '请将播放头移到此属性的某个区段内。',
    reasonNoLine: '请先选择一条判定线。',
    reasonNoRangeStart: '请先设置范围起点（在播放头处开始范围）。',
    apply: '应用',
    generate: '生成',
    cancel: '取消',
    paste: '粘贴',
    copy: '复制',
    previewPaused: '预览因其他编辑而暂停。修改一个值或应用即可继续。',
    countNotes: '{count, plural, other {# 个音符}}',
    countKeys: '{count, plural, other {# 个关键帧}}',
    countSegments: '{count, plural, other {# 个区段}}',
    countNotesKeys: '{notes, plural, other {# 个音符}}，{keys, plural, other {# 个关键帧}}',
    countKeysNotes: '{keys, plural, other {# 个区段}}，{notes, plural, other {# 个音符}}',
    curve: '缓动',
    moreCurves: '更多缓动…',
    curveNumber: '缓动 {id}',
    curvePlain: '{strength}，{shape}',
    curvePart: '{name}（{left} 到 {right} 部分）',
    from: '起始值',
    to: '结束值',
    pattern: '序列',
    patternPlaceholder: '例如 1 -1',
    patternInvalid: '序列必须是以空格分隔的数字，例如 1 -1。',
    jitter: '随机 ±',
    seed: '种子',
    newSeed: '新的随机种子',
    tolerance: '容差',
    equivalentExpression: '等价表达式',
    expressionCopied: '已复制表达式。',
    copyFailed: '浏览器不允许复制。',
    valueNone: '无',
    xOffset: 'X 偏移',
    distributeTitle: '分布 / 渐变',
    distributeNeedsItems: '请选中要分布数值的音符或关键帧。',
    applyTo: '应用于',
    targetNotes: '音符',
    targetKeys: '关键帧',
    change: '修改',
    order: '顺序',
    orderTime: '时间',
    orderX: 'X',
    fieldX: 'X 位置',
    fieldSpeed: '速度',
    fieldSize: '宽度',
    fieldYOffset: '高度偏移',
    fieldVisibleTime: '出现时间（秒）',
    fieldAlpha: '不透明度（0-255）',
    fieldTime: '时间（拍）',
    fieldValue: '数值',
    fieldValueIn: '到达值',
    fieldValueOut: '离开值',
    fieldEasing: '缓动编号',
    how: '方式',
    modeSet: '设为',
    modeAdd: '加上',
    modeMultiply: '乘以',
    modeMax: '取最大',
    modeMin: '取最小',
    modeMirror: '镜像',
    expressionTimeOrder: '表达式按时间顺序作用于各项；此渐变使用 X 顺序，因此在输入框中输入该表达式会得到不同的结果。',
    previewList: '前几项，修改前与修改后',
    previewItem: '#{id}  {before} -> {after}',
    distributeChanged: '{count, plural, other {# 项}}将改变。',
    distributeDone: '已在 {count, plural, other {# 项}}上分布数值。',
    cloneTitle: '克隆到判定线',
    cloneTargets: '目标',
    cloneTargetLines: '选择判定线',
    cloneTargetCreate: '新建判定线',
    cloneNoOtherLines: '还没有其他判定线。请改为新建判定线。',
    sourceLine: '{line}（源）',
    clonePickTargets: '勾选要克隆到的判定线。',
    cloneCount: '数量',
    cloneNamePattern: '名称',
    cloneNameHint: '{k} 会被替换为 0、1、2 ……，{n} 会被替换为 1、2、3 ……',
    copyParent: '与源相同的父线',
    copyZ: '相同的绘制顺序',
    copyGroup: '相同的分组',
    copyType: '相同的类型（图片、文字、UI 绑定线……）',
    cloneStagger: '每个目标依次错开（拍）',
    cloneExpressionNote: '加到复制到目标的每个值上；第一个目标的 u 为 0，最后一个为 1（与“分布”使用相同的引擎）。',
    clonePerTarget: '每个目标叠加（从第一个到最后一个目标）',
    rampX: 'X',
    rampY: 'Y',
    rampRotate: '旋转',
    rampAlpha: '不透明度',
    rampFrom: '第一个',
    rampTo: '最后一个',
    rampMore: '缓动、序列和随机',
    cloneOverlap: '目标已有运动时',
    overlapReplace: '替换',
    overlapSkip: '跳过',
    overlapNewLayer: '作为新层级添加',
    overlapRefuse: '拒绝',
    cloneCopyNotes: '复制音符',
    cloneNoNotes: '没有选中音符。',
    cloneKeepSource: '保留源',
    cloneNeedsSource: '请先选中要克隆的区段（和音符）。',
    cloneNeedsTargets: '请选择目标判定线，或新建判定线。',
    cloneStatus: '克隆到 {count, plural, other {# 条判定线}}。',
    cloneDone: '已克隆到 {count, plural, other {# 条判定线}}。',
    fillTitle: '填充',
    fillNeedTwo: '请选中两个音符：填充开始处和结束处。',
    fillSameLine: '两个音符必须在同一条判定线上。',
    fillHowTo: '在轨道中选中开始和结束音符（按住 Ctrl 单击第二个），然后再次打开“填充”。',
    fillPickOne: '请只选中一个音符作为填充的开始。',
    fillHeadSet: '已记住填充起点。请选中结束音符，并将其选为终点。',
    fillPickHeadFirst: '请先选取开始音符，再选中结束音符。',
    noteType: '音符类型',
    kindTap: 'Tap',
    kindDrag: 'Drag',
    kindFlick: 'Flick',
    kindHold: 'Hold',
    spacing: '间距',
    spacingEvery: '每隔',
    spacingCount: '数量',
    spacingEveryBeat: '每隔多少放一个音符',
    beatFraction: '{beat} 拍',
    spacingCountLabel: '中间的音符数',
    xCurve: 'X 曲线',
    includeEnds: '把两端的音符也变为此类型',
    propsFrom: '属性来源',
    propsStart: '起始音符',
    propsDefaults: '新音符默认值',
    fillHint: 'X 沿曲线从起始音符变化到结束音符。',
    fillExpressionNote: '每个新音符的 X；t 是音符所在的拍数。将其输入其他音符的 X 输入框，即可让它们具有相同的形状。',
    fillStatus: '{count, plural, other {# 个音符}}。',
    fillDone: '已填充 {count, plural, other {# 个音符}}。',
    pathTitle: '运动路径',
    pathLine: '判定线 {line}',
    pathNeedsLine: '请为路径选择一条判定线。',
    pathNeedsLineBody: '在判定线面板中激活一条判定线，或在预览中单击它，然后再次打开“运动路径”。',
    preset: '形状',
    presetLine: '直线',
    presetArc: '圆弧',
    presetCircle: '圆',
    presetSpiral: '螺旋',
    presetFigure8: '8 字形',
    presetSine: '波浪',
    presetExpr: '表达式',
    pathStart: '开始拍',
    pathEnd: '结束拍',
    fromX: '起点 X',
    fromY: '起点 Y',
    toX: '终点 X',
    toY: '终点 Y',
    centerX: '中心 X',
    centerY: '中心 Y',
    radius: '半径',
    radiusStart: '起始半径',
    radiusEnd: '结束半径',
    fromDeg: '起始角度（度）',
    toDeg: '结束角度（度）',
    startDeg: '起始角度（度）',
    turns: '圈数',
    width: '宽度',
    height: '高度',
    amplitude: '振幅',
    waves: '波数',
    exprX: 'x(t)',
    exprY: 'y(t)',
    exprR: '旋转 r(t)',
    exprROptional: '可选，单位为度',
    exprHelp: 't 在路径上从 0 变到 1（应用时间曲线之后）；beat 是谱面拍数。RPE 的 $t$ 和 Pi 也可以使用。',
    editAsExpressions: '以表达式编辑',
    timeCurve: '时间曲线',
    output: '输出',
    outputLinear: '每拍关键帧数',
    outputFit: '按容差拟合',
    keysPerBeat: '每拍关键帧数',
    tolerancePx: '允许的最大误差',
    layer: '层级',
    layerNew: '新层级（{layer}）',
    layerNewNone: '新层级（没有空闲层级）',
    layerUsed: '层级 {layer}（使用中）',
    layerFree: '层级 {layer}（空）',
    pathOverlap: '该范围内已有运动',
    pathRangeInvalid: '结束必须在开始之后。',
    pathExprInvalid: '请修正 {axis} 表达式。',
    pathFixFields: '请先修正突出显示的输入框。',
    pathHint: '在新层级上，路径会叠加到判定线自身的运动上。路径会绘制在预览中，起点为绿色，终点为红色。',
    pathFromLine: '从判定线的位置开始',
    pathFromLineHint:
      '路径会被平移，使其从判定线当前的位置开始：在开始拍不会跳变，闭合形状（完整的圆、8 字形）会在起点处结束。',
    pathAbsoluteHint:
      '路径的坐标会原样加到判定线的位置上：判定线在开始拍跳到路径的第一个点，并在结束后保持最后一个点的偏移。',
    pathAbsoluteLayerHint:
      '在该范围内，层级 {layer} 使用路径的坐标代替自身的值：在开始拍跳到路径的第一个点，而范围前后的曲线保持不变。',
    pathCentreIgnored: '路径从判定线的位置开始时，中心不起作用。',
    pathEndsRelative: '路径从判定线的位置开始时，只有起点到终点的差值有效：路径会被平移，使其起点位于判定线所在之处。',
    appliedExpressions: '应用的表达式',
    pathStatus: '每个轴 {keys} 个关键帧，最大误差 {error} px。',
    pathDone: '已写入运动路径（{keys} 个关键帧）。',
    bakeTitle: '烘焙或简化',
    bakeHowTo: '在运动列中选中区段，然后打开此工具。',
    bakeMode: '操作',
    bakeModeBake: '切割为直线分段',
    bakeModeSimplify: '简化（拟合曲线）',
    bakeDensity: '每个网格步长的分段数',
    bakeDensityHelp: '每 1/{div} 拍一个分段。',
    bakeAnchor: '分段对齐到',
    bakeAnchorPlayhead: '播放头处的网格',
    bakeAnchorStart: '区段起点',
    bakePartner: '在同一时间内也烘焙另一个位置轴',
    bakeHint: '数值取自精确的曲线。在 X 和 Y 已关联的判定线上，X 和 Y 会保持一起插入关键帧。',
    simplifyHint: '许多短关键帧会变为较少的曲线区段，并保持在容差范围内。',
    bakeFormulaStart: '区段起点',
    bakeFormulaNote:
      '每 1/{div} 拍一个关键帧，数值取自精确的曲线，并以线性连接。不使用此面板时，“切割为直线分段”使用“设置”中的密度。',
    simplifyFormulaNote: '关键帧会合并为较少的带缓动的区段，同时新曲线与旧曲线保持在此误差以内。',
    bakeStatus: '{count, plural, other {# 个分段}}。',
    simplifyStatus: '移除 {removed, plural, other {# 个关键帧}}，最大差异 {error}。',
    bakeDone: '已烘焙为 {count, plural, other {# 个分段}}。',
    simplifyDone: '已简化：移除了 {count, plural, other {# 个关键帧}}。',
    flattenTitle: '合并层级',
    flattenSubtitle: '{line} 的{prop}',
    flattenLayers: '要合并的层级',
    flattenLayerItem: '层级 {layer}：{keys, plural, other {# 个关键帧}}',
    flattenHint: '在层级可以合并的地方保持精确；其他地方变为容差内的短直线分段。',
    flattenFormulaTerm: '层级 {layer}',
    flattenFormulaNote: '在每一拍，层级 0 变为各层级之和；其他层级被移除。',
    flattenExactStatus: '精确：层级 0 上有 {keys} 个关键帧。',
    flattenBakedStatus: '层级 0 上有 {keys} 个关键帧，最大差异 {error}。',
    flattenDone: '已将 {count, plural, other {# 个层级}}合并到层级 0。',
    flattenNothing: '此判定线没有任何属性拥有多个层级。',
    flattenChoose: '合并哪个属性？',
    flattenOneLayer: '此属性只有一个层级：没有可合并的内容。',
    flattenNotLayered: '只有位置、旋转、不透明度和流速有层级。',
    propMoveX: 'X 位置',
    propMoveY: 'Y 位置',
    propRotate: '旋转',
    propAlpha: '不透明度',
    propSpeed: '流速',
    propScaleX: '长度 / 宽度',
    propScaleY: '粗细 / 高度',
    propColor: '颜色',
    propText: '文字',
    propIncline: '倾斜',
    propPaint: '画笔',
    propGif: 'GIF 进度',
    staggerStep: '错开步长',
    staggerBody: '选中内容中每个后续时间点都会多移动一个步长。',
    staggerOption: '{beat} 拍',
    staggerNeedsTwo: '请选中位于两个或更多时间点的项目。',
    staggerDone: '已将 {count, plural, other {# 项}}错开 {beat} 拍。',
    joinDone: '已合并 {count, plural, other {# 个关键帧}}。',
    joinSkipped: '有 {count, plural, other {# 个关键帧}}无法精确合并。“简化”可以在容差内合并它们。',
    simplifyInstead: '简化…',
    reverseDone: '已反转 {count, plural, other {# 个区段}}。',
    linkDone: '已绑定 {count, plural, other {# 个区段}}：现在编辑其中一个会同时编辑全部。',
    selectedLinked: '已选中 {count, plural, other {# 个绑定的区段}}。',
    splitRpeDone: '已按 RPE 的线性规则拆分（拆分后的曲线形状会改变）。',
    similarLine: '已在此判定线上选中 {count, plural, other {# 个相似项}}。再按一次可选中所有判定线上的。',
    similarAllLines: '已在所有判定线上选中 {count, plural, other {# 个相似项}}。',
    rangeStartSet: '范围从 {beat} 开始。在结束处右键单击（或移动播放头），然后选择“范围到此处结束”。',
    rangeSelected: '已选中 {notes, plural, other {# 个音符}}和 {keys, plural, other {# 个关键帧}}。',
    everyNthArg: '每隔 N 项保留一项',
    everyNthOption: '每 {n, plural, other {#}} 项保留一项',
    transformTitle: '变换',
    transformDescription: '精确地移动和缩放 {count, plural, other {# 项}}。',
    transformTime: '时间',
    transformX: 'X（音符）',
    timeOffset: '移动（拍）',
    timeScale: '时间缩放',
    scaleNone: '不变',
    scaleStretch: '拉伸 {p}/{q}',
    scaleSqueeze: '压缩 {p}/{q}',
    scaleCustom: '自定义比例',
    scaleP: '乘以',
    scaleQ: '除以',
    timePivot: '缩放中心',
    pivotStart: '开头（{beat}）',
    pivotEnd: '结尾（{beat}）',
    pivotPlayhead: '播放头（{beat}）',
    xScale: 'X 缩放',
    xPivot: 'X 缩放中心',
    xPivotZero: '判定线中心（0）',
    xPivotCenter: '选区中心（{x}）',
    transformXHint: 'X 的变化只作用于音符；关键帧只在时间上移动。',
    transformNothing: '请选中要变换的音符或关键帧。',
    transformStatus: '变换 {count, plural, other {# 项}}。',
    transformDone: '已变换 {count, plural, other {# 项}}。',
    reverseTimeDone: '已在时间上反转 {count, plural, other {# 项}}。',
    pasteSpecialTitle: '选择性粘贴',
    pasteMode: '粘贴为',
    pasteNormal: '普通',
    pasteAddValues: '叠加数值',
    pasteNewLayer: '新层级',
    pasteNeedsKeys: '剪贴板中没有关键帧。',
    pasteMirror: '镜像（X 和数值取反）',
    pasteAnchor: '放置于',
    anchorMouse: '鼠标处',
    anchorPlayhead: '播放头处',
    anchorOriginal: '原来的拍数',
    anchorMouseShort: '放在鼠标处',
    anchorPlayheadShort: '放在播放头处',
    anchorOriginalShort: '放在原来的拍数（从 {beat} 起）',
    pasteTargetLine: '目标判定线',
    pasteTargets: '判定线',
    targetCurrent: '目标判定线',
    targetOriginal: '原来的判定线',
    originalLines: '它们原来的判定线',
    repeat: '次数',
    repeatEvery: '间隔（拍）',
    repeatEveryInvalid: '重复间隔必须大于零。',
    pasteSummary:
      '将 {notes, plural, other {# 个音符}}和 {keys, plural, other {# 个关键帧}}{kind, select, addValues {的数值叠加} asNewLayer {作为新层级粘贴} other {粘贴}}到 {line}，{anchor}{repeat, plural, =1 {} other {，每隔 {every} 拍重复，共 # 次}}{x, select, 0 {} other {，X {x}}}{mirror, select, yes {，镜像} other {}}。',
    clipboardEmpty: '剪贴板为空。请先复制音符或关键帧。',
    pasteDone: '已在 {beat} 粘贴 {notes, plural, other {# 个音符}}和 {keys, plural, other {# 个关键帧}}。',
    settingBakeDensity: '烘焙：每个网格步长的分段数',
    settingBakeDensityHelp: '“切割为直线分段”切割区段的精细程度（RPE 的切割密度）。默认为 8。',
    settingPathPerBeat: '运动路径：每拍关键帧数',
    settingPathPerBeatHelp: '“运动路径”工具的初始密度。默认为 8。',
    helpToolsTitle: '批量工具',
    helpToolsBody:
      '选中音符或关键帧，然后从“工具”菜单、右键菜单或命令面板打开一个工具。其面板打开时，结果会实时显示在轨道、运动列和预览中；Enter 将其作为一个可撤销的步骤应用，Esc 取消。每个工具都会显示它使用的表达式或设置，方便你手动重复。',
    helpDistributeTitle: '分布与渐变数值',
    helpDistributeBody:
      '“分布”按时间顺序将数值分布到选中的项目上：沿一条曲线从第一个值变化到最后一个值，可选择乘以一个重复的序列（1 -1 会交替正负号），并可加入带种子的随机。“设为”替换数值；“加上”“乘以”“取最大”“取最小”和“镜像”会将其与当前值组合。RPE：MultiNote / MultiEvent 编辑器（高批）。',
    helpPathTitle: '运动路径',
    helpPathBody:
      '“运动路径”让判定线在两拍之间沿某个形状（圆、圆弧、螺旋、波浪……）或表达式 x(t) 和 y(t) 移动。默认会在新层级上写入线性关键帧，使判定线自身的运动继续在下方播放。RPE：复杂移动（曲线轨迹生成器）。',
    helpFlattenTitle: '层级与合并',
    helpFlattenBody:
      '位置、旋转、不透明度和速度可以有多个相加的层级。“合并”会将它们合并到层级 0：能精确合并的地方保持精确，其他地方变为你设定的容差内的短直线分段。',
    cmdCloseSheet: '关闭工具面板',
    fillPickTailHint: '将选中的音符设为填充的终点',
    reasonNoSheet: '没有打开的工具面板',
    cmdSelectNone: '取消选择',
    reasonNothingToClear: '没有选中任何内容',
  },
};

export default catalog;
